"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "code": "KRGSRBTHB",
    "vendor": "krungsri",
    "name": {
        "en": "KRGSRBTHB"
    },
    "type": "digital",
    "exponent": 2,
    "status": "active",
    "parentCode": "THB",
    "parentCurrencyMultiplier": 1
};
